// Bank accounts (/bank-account-management). Stored values are shown as typed.
const bankAccounts = {
  page: {
    title: 'Bank Accounts',
    subtitle: 'Manage company accounts, IBANs and payment / deduction definitions.',
  },
  actions: {
    add: 'Add Account',
  },
  stats: {
    total: 'Saved Accounts',
    totalShort: 'Accounts',
    active: 'Active',
    activeShort: 'Active',
    passive: 'Passive / Closed',
    passiveShort: 'Passive',
    pending: 'Pending',
    pendingShort: 'Pending',
    share: '{{percent}}% of accounts',
  },
  toolbar: {
    search: 'Search by company, branch, IBAN or description…',
    searchShort: 'Search accounts…',
    status: 'Status',
    groups: {
      all: 'All',
      active: 'Active',
      passive: 'Passive',
      pending: 'Pending',
    },
  },
  fields: {
    firma: 'Company',
    sube: 'Branch',
    hesapNo: 'Account No / IBAN',
    dosyaAciklama: 'File Description',
    odemeKesinti: 'Payment / Deduction',
    odemeTuru: 'Payment Type',
    odemeAciklama: 'Payment Description',
    odemeDonemi: 'Payment Period',
    durum: 'Status',
  },
  table: {
    listLabel: 'Saved bank accounts',
    empty: 'No accounts match the filters',
    none: 'There are no saved accounts yet.',
    rangeOf: 'of {{total}} accounts',
    ofTotal: 'out of {{total}} accounts',
    jump: 'Go to page',
  },
  panel: {
    label: 'Selected account',
    heading: 'Account',
    edit: 'Edit',
  },
  form: {
    newTitle: 'New Account',
    editTitle: 'Edit Account',
    subtitle: 'All fields are required.',
    sections: {
      company: 'Company and account',
      payment: 'Payment details',
      status: 'Status',
    },
    placeholder: 'Enter {{field}}',
    odemeAciklamaHint: 'Describe it if the payment type is “Other”.',
    required: 'This field is required',
    cancel: 'Cancel',
    save: 'Save',
    update: 'Update',
    saving: 'Saving…',
  },
  toast: {
    loadError: 'Error loading accounts: {{message}}',
    fillAll: 'Please fill in all fields.',
    added: 'Record added successfully!',
    updated: 'Record updated successfully!',
    saveError: 'An error occurred: {{message}}',
    updateError: 'Error while updating: {{message}}',
    pageJumpInvalid: 'Please enter a page number between 1 and {{max}}.',
  },
};

export default bankAccounts;
